<template>
	<div class="scrollable only-y">
		<el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
			<div class="page-header card-base card-shadow--medium">
				<h2 class="no-m white-text"><i class="mdi mdi-clock-in widget-icon accent-text fs-30"></i> {{ $t('menu.queue') }}</h2>
			</div>
		</el-col>

		<el-card>
			<template>
				<el-table v-loading="loadingQueueList"
					:data="queueList"
					style="width: 100%">
					<el-table-column
						fixed
						prop="number"
						label="Number"
						width="150">
					</el-table-column>

					<el-table-column
						prop="job"
						label="Active"
						width="120">
						<template slot-scope="scope">
							<span>
								{{ scope.row.job.active }}
							</span>
						</template>
					</el-table-column>

					<el-table-column
						prop="job"
						label="Completed"
						width="120">
						<template slot-scope="scope">
							<span>
								{{ scope.row.job.completed }}
							</span>
						</template>
					</el-table-column>
					
					<el-table-column
						prop="job"
						label="Waiting"
						width="120">
						<template slot-scope="scope">
							<span>
								{{ scope.row.job.waiting }}
							</span>
						</template>
					</el-table-column>

					<el-table-column
						prop="job"
						label="Paused"
						width="120">
						<template slot-scope="scope">
							<span>
								{{ scope.row.job.paused }}
							</span>
						</template>
					</el-table-column>

					<el-table-column
						prop="job"
						label="Delayed"
						width="120">
						<template slot-scope="scope">
							<span>
								{{ scope.row.job.delayed }}
							</span>
						</template>
					</el-table-column>

					<el-table-column
						prop="job"
						label="Failed"
						width="120">
						<template slot-scope="scope">
							<span>
								{{ scope.row.job.failed }}
							</span>
						</template>
					</el-table-column>
					
					<el-table-column
						prop="job"
						label="Is Paused"
						width="120">
						<template slot-scope="scope">
							<span v-if="scope.row.isPaused==false">
								<span>Running</span>
							</span>
							<span v-else-if="scope.row.isPaused==true">
								<span>Paused</span>
							</span>
							<span v-else>
								<span>-</span>
							</span>
						</template>
					</el-table-column>
					
					<!-- <el-table-column label="Action" width="200">
						<template slot-scope="props">
							<el-row :gutter="24">
								<el-col v-if="props.row.isPaused === true" :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
									<el-button type="primary" :loading="loadingBtnResume" @click="resumeQueue(props.row.number)">
										<i class="mdi mdi-play" />
										{{ 'Resume' }}
									</el-button>
								</el-col>
								<el-col v-else-if="props.row.isPaused === false" :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
									<el-button type="danger" :loading="loadingBtnPause" @click="pauseQueue(props.row.number)">
										<i class="mdi mdi-pause" />
										{{ 'Pause' }}
									</el-button>
								</el-col>
							</el-row>
						</template>
					</el-table-column> -->

					<el-table-column
						fixed="right"
						label="Operations"
						width="120">
						<template slot-scope="scope">
							<span v-if="scope.row.isPaused==true">
								<el-button type="primary" :loading="btnResumeLoading" @click="resumeQueue(scope.row)">
									<i class="mdi mdi-play" />
									{{ 'Resume' }}
								</el-button>
							</span>
							<span v-else-if="scope.row.isPaused==false">
								<el-button type="danger" :loading="btnPauseLoading" @click="pauseQueue(scope.row)">
									<i class="mdi mdi-pause" />
									{{ 'Pause' }}
								</el-button>
							</span>
							<span v-else>
								<span>-</span>
							</span>
						</template>
					</el-table-column>
				</el-table>
			</template>
		</el-card>
		<el-card class="mt-20 mb-20 card-base" style="border:none; color:white;">
			DAM Corp.
		</el-card>
	</div>
</template>

<script>
import api from '@/networkClient'
import config from '@/config'
import Template from './consumen/Template.vue'
const moment = require('moment')

export default {
  components: { Template },
	name: 'Queue',
	data () {
		return {
			loadingQueueList: false,
			queueList: [],
			btnPauseLoading: false,
			btnResumeLoading: false
		}
	},
	methods: {
		getQueueList(){
			this.loadingQueueList = true
			api({
				method: 'post',
				url: 'whatsapp/queue/all'
			}).then(response => {
				let data =
					response &&
					response.data &&
					response.data.data &&
					response.data.data.data
						? response.data.data.data
						: [];
				this.queueList = data
				this.loadingQueueList = false
			}).catch(error => {
				console.log("error",error)
				this.loadingQueueList = false
			})
		},
		stopQueue(key){
			api({
				method: 'post',
				url: 'whatsapp/queue/paused',
				data: {
					number: key.number.charAt(0) == 6 && key.number.charAt(1) == 2 ? '0' + key.number.substring(2) : key.number
				}
			}).then(response => {
			}).catch(error => {
				console.log("error",error)
			})
		},
		resumeQueue(key) {
			var phoneNumber = 
				key &&
				key.number
					? key.number
					: '';
			this.btnResumeLoading = true;
			const number = phoneNumber.split('');
			if (number[0] === '6') {
				number.shift();
			}
			if (number[0] === '2') {
				number.shift();
				number.unshift('0');
			}
			let validNumber = number.join("");
			api({
				method: 'post',
				url: 'whatsapp/queue/resume',
				data: {
					number: validNumber
				}
			}).then(response => {
				let status =
					response &&
					response.data &&
					response.data.ec
						? response.data.ec
						: null;
				if(status === 200) {
					this.$swal(this.$t('success'), 'Queue has been resume', "success")
				}
				this.getQueueList()
				this.btnResumeLoading = false;
			}).catch(error => {
				console.error(error);
				this.btnResumeLoading = false;
			})
		},
		pauseQueue(key) {
			var phoneNumber = 
				key &&
				key.number
					? key.number
					: '';
			this.btnPauseLoading = true;
			const number = phoneNumber.split('');
			if (number[0] === '6') {
				number.shift();
			}
			if (number[0] === '2') {
				number.shift();
				number.unshift('0');
			}
			let validNumber = number.join("");
			api({
				method: 'post',
				url: 'whatsapp/queue/paused',
				data: {
					number: validNumber
				}
			}).then(response => {
				let status =
					response &&
					response.data &&
					response.data.ec
						? response.data.ec
						: null;
				let message =
					response &&
					response.data &&
					response.data.message
						? response.data.message
						: '';
				if(status === 200) {
					this.$swal(this.$t('success'), 'Queue has been pause', "success")
				} else {
					this.$swal(this.$t('error'), message, "error")
				}
				this.getQueueList()
				this.btnPauseLoading = false;
			}).catch(error => {
				console.error(error);
				this.btnPauseLoading = false;
			})
		}
	},
	async mounted(){
		this.getQueueList()
	}
}
</script>

<style lang="scss" scoped>
.float-image {
	float:right;
	z-index: 1;
	bottom: 10px;
	left: 10px;
}
.gradient-api {
	background:#249393;
	background: linear-gradient(260deg, #4ac5c5, #249393);
}
.white-text {
	color: white;
}
.page-header {
	margin-bottom: 30px;
}
</style>
